import React, { useContext, useEffect, useState } from "react";
import { Heading, Input, RichTextEditor, SectionHeading, SectionSamples } from "../../../components";
import { deleteIcon, Plus } from "../../../components/Icons/Icons";
import { ResumeContext } from "../../../contexts/resumeContext";
import styles from "./ProfessionalExperienceForm.module.css";

function ProfessionalExperienceForm() {
  const newProfessionalExpBlock = {
    jobTitle: "",
    company: "",
    location: "",
    description: "",
  };

  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);
  const [professionalDetails, setProfessionalDetails] = useState(
    Object.values(
      resumeInfo.professionalDetails || { 0: { ...newProfessionalExpBlock } }
    ) || [{}]
  );

  useEffect(() => {
    updateResumeInfo.current(
      "professionalDetails",
      professionalDetails,
      resumeInfo
    );
  }, [professionalDetails]);

  const handleChange = (e, ix) => {
    let professionalDetailsArr = [...professionalDetails];
    let professionalDetailsObj = professionalDetailsArr[ix];
    if(e.target.type === "checkbox"){
      professionalDetailsObj[e.target.name] = e.target.checked ? e.target.value : null;    
    }
    else{
      professionalDetailsObj[e.target.name] = e.target.value;
    }
    professionalDetailsArr[ix] = professionalDetailsObj;
    setProfessionalDetails(professionalDetailsArr);
  };

  const addBlock = () => {
    let professionalDetailsArr = [
      ...professionalDetails,
      { ...newProfessionalExpBlock },
    ];
    setProfessionalDetails(professionalDetailsArr);
  };

  const deleteBlock = (ix) => {
    const professionalDetailsArr = [...professionalDetails];
    professionalDetailsArr.splice(ix, 1);
    setProfessionalDetails(professionalDetailsArr);
  };

  console.log(professionalDetails)

  return (
    <div>
      <SectionHeading
        editable
        section="WE"
        content="Professional Experience"
        subheading={<>Show your relevant experience. Use bullet points to note your achievements, if possible - use numbers/facts (Achieved X, measured by Y, by doing Z). <SectionSamples section="WE"/></>}
      />
      {professionalDetails.map((exp, ix) => (
        <div className="block" key={`pr_${ix}`}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="Job Title"
                name="jobTitle"
                onChange={(e) => handleChange(e, ix)}
                value={exp.jobTitle}
              />
            </div>
            <div className="col">
              <Input
                label="Company/Employer"
                name="company"
                onChange={(e) => handleChange(e, ix)}
                value={exp.company}
              />
            </div>
          </div>
          <div className="row">
            <div className="col" style={{ marginBottom: "1em" }}>
              <Input
                type="month"
                label="Start Date"
                name="startDate"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.startDate}
              />
            </div>
            <div className="col">
              <Input
                type="month"
                label="End Date"
                name="endDate"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.endDate}
                disabled={exp.endDate === "Present"}
              />
              <label className={styles.presentLabel}>
                <input 
                  type="checkbox"
                  value="Present"
                  name="endDate"
                  onChange={e => handleChange(e, ix)}
                  checked={exp.endDate === "Present"}
                />
                Present
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Location"
                name="location"
                onChange={(e) => handleChange(e, ix)}
                value={exp.location}
              />
            </div>
          </div>
          <div className="row">
            <RichTextEditor
              value={exp.description}
              placeholder="Write 4-5 crisp bullets. Take care to mention numbers and figures. Bold appropritate text to highlight important things"
              onChange={(value) =>
                handleChange({ target: { name: "description", value } }, ix)
              }
            />
          </div>
        </div>
      ))}
      <button className="link" onClick={addBlock}>
        Add More Experience <Plus />
      </button>
    </div>
  );
}

export default ProfessionalExperienceForm;
